// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__21gC7","form":"styles_form__2Ma_7"};